import { useSyncExternalStore } from "react";

import { getQueueSnapshot, subscribeQueue, type QueueSnapshot } from "./queue";

/**
 * Stand der Warteschlange für die Oberfläche.
 *
 * `useSyncExternalStore` statt eigener Zustandsverwaltung: Die Warteschlange
 * läuft auch, wenn keine Komponente sie beobachtet — sie ist die Quelle, nicht
 * React. So bleiben Anzeige und Datenbank auch bei einem Wechsel der Ansicht
 * mitten in einer Übertragung deckungsgleich.
 */
export function useQueue(): QueueSnapshot {
  return useSyncExternalStore(subscribeQueue, getQueueSnapshot, getQueueSnapshot);
}
